module.exports = __webpack_public_path__ + "static/img/examshare_lbt_pic2.124874a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examshare_lbt_pic2.png
// module id = YORJ
// module chunks = 0